import { render, staticRenderFns } from "./BlockUnblock.vue?vue&type=template&id=504657e6&scoped=true&"
import script from "./BlockUnblock.vue?vue&type=script&lang=js&"
export * from "./BlockUnblock.vue?vue&type=script&lang=js&"
import style0 from "./BlockUnblock.vue?vue&type=style&index=0&id=504657e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504657e6",
  null
  
)

export default component.exports